import React from 'react';
import { currency, c } from '../../utils';
import classes from './PricingPlan.module.scss';

interface Props {
  className?: string;
  monthlyFee: number;
}

// [2026-03-08] Helper to determine the pricing frequency string (monthly vs annual)
function getPrice({ monthlyFee }) {
  const priceUnit = !!monthlyFee ? 'monthly' : 'annual';

  return `${currency(monthlyFee)}/${priceUnit}`;
}

// [2026-03-08] Component to display the formatted plan price
export function PlanPriceLabel({ monthlyFee }: Props) {
  return <p className={c(classes.PriceLabel)}>{getPrice({ monthlyFee })}</p>;
}

export default PlanPriceLabel;
